import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import classnames from "../../utils/classnames.js";
import Dropdown from "../Dropdown/Dropdown.js";
import './Header.css';/* empty css            */
const HeaderSort = ({ title, items, onSelect, value }) => {
  const selectedItem = useMemo(() => {
    return items.find((item) => item.key === value) || items[0];
  }, [items, value]);
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-header-sort"), children: /* @__PURE__ */ jsx(Dropdown, { items, title, onSelect, selected: selectedItem }) });
};
export {
  HeaderSort as default
};
//# sourceMappingURL=HeaderSort.js.map
